<template>
  <div>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col>
          <el-button type="primary" @click="openImgDialog">添加横幅图</el-button>
          <el-button type="success" @click="openRobotDialog">首次询问自动回复设置</el-button>
          <el-button type="success" @click="openContactDialog">联系方式</el-button>
        </el-col>
      </el-row>

      <!-- 表格区域 -->
      <el-table :data="sessionList" style="width: 100%" border stripe>
        <el-table-column type="index" />
        <el-table-column prop="company" label="公司" width="200"/>
        <el-table-column prop="visitorName" label="姓名" width="180"/>
        <el-table-column prop="phone" label="手机号" width="180" />
        <el-table-column prop="email" label="邮箱" width="180"/>
        <el-table-column prop="wechat" label="微信" width="180"/>
        <el-table-column prop="whatsapp" label="WhatsApp" width="180"/>
        <el-table-column label="留言内容">
          <template #default="scope">
            <div style="white-space: pre-wrap;overflow-wrap: break-word;">{{ scope.row.context }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="lastMessageAt" label="提交时间" width="200"/>
        <el-table-column prop="readStatus" label="是否已读" width="80">
          <template #default="scope">
            <span :style="{ color: scope.row.isRead === 0 ? 'red' : 'green' }">{{ scope.row.isRead === 0 ? '未读' : '已读' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template #default="scope">
            <!-- 回复按钮 -->
            <el-tooltip
              effect="dark"
              content="回复"
              placement="top"
              :enterable="false"
            >
              <el-button type="success" icon="el-icon-chat-line-round" size="mini" @click="openReplyDialog(scope.row)"></el-button>
            </el-tooltip>
            <!-- 已读按钮 -->
            <el-tooltip
              effect="dark"
              content="已读"
              placement="top"
              :enterable="false"
            >
              <el-button type="primary" icon="el-icon-check" size="mini" @click="handleEdit(scope.$index, scope.row)"></el-button>
            </el-tooltip>
            <!-- 删除按钮 -->
            <el-tooltip
              effect="dark"
              content="删除"
              placement="top"
              :enterable="false"
            >
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.$index, scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pageNum"
        :page-sizes="[5, 8, 10, 20]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

      <!-- 添加横幅图dialog -->
      <el-dialog
        title="联系我们横幅图"
        :visible.sync="imgDialogVisible"
        width="30%"
        :before-close="closeImgDialog"
        center
      >
        <el-upload
          action="string"
          :http-request="settingTopBackground"
          accept=".png,.jpg,.jpeg"
          :show-file-list="false">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <div class="topBackgroundImg">
          <img :src="topBackgroundImg" alt="">
        </div>
        <div class="uploadTip">建议上传相同比例的横幅图</div>
      </el-dialog>

      <el-dialog
        title="首次询问自动回复设置"
        :visible.sync="robotDialogVisible"
        width="520px"
        center
      >
        <el-form label-width="100px">
          <el-form-item label="启用状态">
            <el-switch v-model="robotForm.enable"></el-switch>
          </el-form-item>
          <el-form-item label="回复内容">
            <el-input
              v-model.trim="robotForm.content"
              type="textarea"
              :rows="6"
              placeholder="请输入用户首次咨询时自动回复的内容"
            />
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="robotDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveRobotConfig">保 存</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :title="`留言回复 - ${activeSession.visitorName || ''}`"
        :visible.sync="replyDialogVisible"
        width="680px"
        center
      >
        <div class="reply-list" ref="replyBox">
          <div
            class="reply-item"
            v-for="item in messageList"
            :key="item.id || item.createdAt + item.content"
            :class="item.senderName == 'admin' ? 'is-admin' : 'is-visitor'"
          >
            <div class="reply-content">{{ item.context || item.content }}</div>
            <div class="reply-meta">{{ item.senderName == 'admin' ? '客服' : '访客' }} · {{ item.createdAt }}</div>
          </div>
          <div v-if="messageList.length === 0" class="reply-empty">暂无会话内容</div>
        </div>

        <el-input
          v-model.trim="replyContent"
          type="textarea"
          :rows="4"
          placeholder="请输入回复内容"
        />

        <span slot="footer">
          <el-button @click="replyDialogVisible = false">关 闭</el-button>
          <el-button type="primary" @click="submitReply">发 送 回 复</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="联系方式设置"
        :visible.sync="contactDialogVisible"
        width="520px"
      >
        <el-form label-width="100px">
          <el-form-item label="商务电话">
            <el-input v-model="contactForm.tel"></el-input>
          </el-form-item>
          <el-form-item label="联系人">
            <el-input v-model="contactForm.name"></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="contactForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="WhatsApp">
            <el-input v-model="contactForm.whatsapp"></el-input>
          </el-form-item>
          <el-form-item label="微信">
            <el-input v-model="contactForm.wechat"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="contactForm.email"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="contactDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveContactInfo">保 存</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  settingTopBackground,
  getTopBackground,
  getSessionList,
  setReadStatus,
  deleteSession,
  getRobotConfig,
  updateRobotConfig,
  getAdminSessionMessages,
  replySessionMessage,
  getAdminContactInfo,
  setContactInfo
} from '@/api/editContactUs'
export default {
  data () {
    return {
      queryInfo: {
        pageNum: 1, // 当前的页数
        pageSize: 10 // 当前显示的多少条数据
      },
      sessionList: [],
      total: 0,
      imgDialogVisible: false,
      topBackgroundImg: '', // 横幅图图片
      robotDialogVisible: false,
      robotForm: {
        enable: true,
        content: ''
      },
      replyDialogVisible: false,
      activeSession: {},
      messageList: [],
      replyContent: '',
      contactDialogVisible: false,
      contactForm: {
        tel: '',
        name: '',
        phone: '',
        whatsapp: '',
        wechat: '',
        email: ''
      }
    }
  },
  mounted () {
    this.getSessionList()
    // 监听更新
    this.$bus.$on('updateGetMessage', this.updateGetMessage)
  },
  beforeDestroy () {
    // 组件销毁前移除监听
    this.$bus.$off('updateGetMessage', this.updateGetMessage)
  },
  methods: {
    getSessionList () {
      getSessionList(this.queryInfo).then(res => {
        if (res.code == 0) {
          this.sessionList = res.data.rows
          this.total = res.data.total
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 分页功能下拉选择器触发
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
      this.getSessionList()
    },
    // 监听页码值改变
    handleCurrentChange (newSize) {
      this.queryInfo.pageNum = newSize
      this.getSessionList()
    },
    // 点击编辑已读
    handleEdit (index, row) {
      this.$confirm('将此消息标记为已读, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setReadStatus(row.id).then(res => {
          if (res.code == 0) {
            this.$bus.$emit('updateUnreadCount')
            this.$message.success('操作成功！')
            this.getSessionList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 点击删除
    handleDelete (index, row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSession(row.id).then(res => {
          if (res.code == 0) {
            this.$bus.$emit('updateUnreadCount')
            this.$message.success('删除成功！')
            this.getSessionList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 打开横幅图dialog
    openImgDialog () {
      this.imgDialogVisible = true
      this.getTopBackground()
    },
    // 添加或编辑联系我们横幅图
    settingTopBackground (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      settingTopBackground(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.getTopBackground()
        }
      })
    },
    // 获取顶部图片
    getTopBackground () {
      getTopBackground().then(res => {
        if (res.code == 0) {
          this.topBackgroundImg = res.data.value
        } else {
          this.$message.error('获取关于我们横幅图失败！')
        }
      })
    },
    // 添加横幅图dialog关闭
    closeImgDialog () {
      this.imgDialogVisible = false
    },
    async openRobotDialog () {
      this.robotDialogVisible = true
      const res = await getRobotConfig()
      if (res.code == 0 && res.data) {
        this.robotForm.enable = res.data.enable != 0
        this.robotForm.content = res.data.content || ''
      }
    },
    async saveRobotConfig () {
      // if (!this.robotForm.content && this.robotForm.enable) {
      //   this.$message.error('请先填写自动回复内容')
      //   return
      // }
      const params = {
        enable: this.robotForm.enable ? 1 : 0,
        content: this.robotForm.content
      }
      const res = await updateRobotConfig(params)
      if (res.code == 0) {
        this.$message.success('保存成功')
        this.robotDialogVisible = false
      } else {
        this.$message.error(res.msg || '保存失败')
      }
    },
    async openReplyDialog (row) {
      this.activeSession = row
      this.replyDialogVisible = true
      await this.fetchSessionMessages(row.id)
      if (row.isRead == 0) {
        await setReadStatus(row.id)
        this.$bus.$emit('updateUnreadCount')
        this.getSessionList()
      }
    },
    // 加载当前会话的所有消息，通常在对话打开或收到新消息时调用
    async fetchSessionMessages (sessionId) {
      const res = await getAdminSessionMessages(sessionId)
      if (res.code == 0) {
        this.messageList = res.data || []
        this.scrollToBottom()
      } else {
        this.$message.error(res.msg || '获取会话失败')
      }
    },
    async submitReply () {
      if (!this.activeSession.id) return
      if (!this.replyContent) {
        this.$message.error('请输入回复内容')
        return
      }
      const params = {
        sessionId: this.activeSession.id,
        content: this.replyContent
      }
      const res = await replySessionMessage(params)
      if (res.code == 0) {
        this.$message.success('回复成功')
        this.replyContent = ''
        this.fetchSessionMessages(this.activeSession.id)
      } else {
        this.$message.error(res.msg || '回复失败')
      }
    },
    // 打开回复对话框后自动滚动到底部
    scrollToBottom () {
      this.$nextTick(() => {
        const replyBox = this.$refs.replyBox
        if (replyBox) {
          replyBox.scrollTop = replyBox.scrollHeight
        }
      })
    },
    // 收到新消息时更新当前会话的消息列表
    async updateGetMessage () {
      if (this.replyDialogVisible) {
        await this.fetchSessionMessages(this.activeSession.id)
        await setReadStatus(this.activeSession.id)
        this.$bus.$emit('updateUnreadCount')
      }
      await this.getSessionList()
    },
    // 打开联系方式设置对话框
    openContactDialog () {
      this.contactDialogVisible = true
      // 获取联系方式
      this.getContactInfo()
    },
    // 获取联系方式
    getContactInfo () {
      getAdminContactInfo().then(res => {
        if (res.code == 0) {
          this.contactForm = {
            tel: res.data.tel || '',
            name: res.data.name || '',
            phone: res.data.phone || '',
            email: res.data.email || '',
            whatsapp: res.data.whatsapp || '',
            wechat: res.data.wechat || ''
          }
        } else {
          this.$message.error('res.msg')
        }
      })
    },
    // 保存联系方式设置
    saveContactInfo () {
      // 全世界手机号码正则表达式（简单版）
      var phoneReg = /^\+?[\d\s\-()]+$/
      // 简单的邮箱正则表达式
      var emailReg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
      if (!this.contactForm.tel) {
        this.$message.error('商务电话号码不能为空')
        return
      }
      if (this.contactForm.tel && !phoneReg.test(this.contactForm.tel)) {
        this.$message.error('请输入有效的商务电话号码')
        return
      }
      if (!this.contactForm.name) {
        this.$message.error('联系人不能为空')
        return
      }
      if (!this.contactForm.phone) {
        this.$message.error('联系电话不能为空')
        return
      }
      if (this.contactForm.phone && !phoneReg.test(this.contactForm.phone)) {
        this.$message.error('请输入有效的联系电话号码')
        return
      }
      if (!this.contactForm.email) {
        this.$message.error('邮箱地址不能为空')
        return
      }
      if (this.contactForm.email && !emailReg.test(this.contactForm.email)) {
        this.$message.error('请输入有效的邮箱地址')
        return
      }
      setContactInfo(this.contactForm).then(res => {
        if (res.code == 0) {
          this.$message.success('保存成功！')
          this.contactDialogVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.reply-list{
  max-height: 320px;
  overflow-y: auto;
  margin-bottom: 14px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;
}
.reply-list::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.reply-item{
  margin-bottom: 10px;
  .reply-content{
    display: inline-block;
    padding: 8px 10px;
    border-radius: 8px;
    max-width: 88%;
    word-break: break-word;
    line-height: 1.6;
  }
  .reply-meta{
    color: #999;
    font-size: 12px;
    margin-top: 4px;
  }
}
.is-admin{
  text-align: right;
  .reply-content{
    background: #1677ff;
    color: #fff;
  }
}
.is-visitor{
  text-align: left;
  .reply-content{
    background: #fff;
    border: 1px solid #ebeef5;
    color: #333;
  }
}
.reply-empty{
  color: #999;
  text-align: center;
  padding: 20px 0;
}
.topBackgroundImg{
  width: 100%;
  height: 180px;
  border: 1px solid;
  margin-top: 20px;
  img{
    width: 100%;
    height: 100%;
  }
}

.uploadTip{
  font-size: 12px;
  color: red;
  margin-top: 5px;
}
</style>
